@if (dataSource || uploadedFile) {
  <div class="datasource-info-panel">
    <div class="panel-content p-lg">

      <!-- Stats Section -->
      <div class="stats-section">
        <div class="stats-grid">
          <!-- File Type (for uploaded files) -->
          @if (isUploadedFile && uploadedFile?.data?.fileType) {
            <div class="info-section">
              <div class="info-label text-secondary">File Type</div>
              <div class="info-value text-uppercase">{{ uploadedFile!.data.fileType }}</div>
            </div>
          }

          <!-- Created Date -->
          @if (createdDate) {
            <div class="info-section">
              <div class="info-label text-secondary">{{ isUploadedFile ? 'Uploaded' : 'Created' }}</div>
              <div class="info-value">{{ formatDate(createdDate) }}</div>
            </div>
          }

          <!-- Updated Date (only for existing datasources) -->
          @if (updatedDate && !isUploadedFile) {
            <div class="info-section">
              <div class="info-label text-secondary">Last Updated</div>
              <div class="info-value">{{ formatDate(updatedDate) }}</div>
            </div>
          }
        </div>

        @if (dataSource && dataSource.dataSourceTypeId === 3 && dataRows.length > 0 && !loadingData) {
          <div class="data-table-info-inline text-secondary">
            Showing first {{ dataRows.length }} rows
          </div>
        }
      </div>

      <!-- API Listener Info Section -->
      @if (isApiListener) {
        <div class="info-section api-listener-section">
          <div class="info-box p-md">
            <div class="flex align-center gap-8">
              <mat-icon svgIcon="api" class="api-icon"></mat-icon>
              <div class="flex-1">
                <div class="font-semibold">API Listener Datasource</div>
                <div class="text-secondary">{{ hasSchema ? 'Schema defined - ready to receive data' : 'Awaiting schema definition' }}</div>
              </div>
            </div>
          </div>
          
          @if (schemaColumns.length > 0) {
            <div class="schema-columns">
              <div class="section-label text-secondary">Expected Schema ({{ schemaColumns.length }} columns)</div>
              <div class="schema-grid">
                @for (column of schemaColumns; track column.columnName) {
                  <div class="schema-card">
                    <div class="schema-card-header">
                      <span class="schema-column-name">{{ column.columnName }}</span>
                      <div class="schema-data-type">({{ column.dataType }})</div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- Columns List (only when NOT showing data table and NOT API Listener) -->
      @if (columns.length > 0 && (!dataSource || (dataSource.dataSourceTypeId !== 3 && dataSource.dataSourceTypeId !== 1))) {
        <div class="info-section">
          <div class="columns-list">
            @for (column of columns; track column.name) {
              <div class="column-item">
                <mat-icon svgIcon="table_chart" class="column-icon"></mat-icon>
                <div class="column-details">
                  <span class="column-name">{{ column.name }}</span>
                  @if (column.type) {
                    <span class="column-type">{{ column.type }}</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Data Table (for Upload File type datasources) -->
      @if (dataSource && dataSource.dataSourceTypeId === 3) {
        <div class="info-section data-table-section">
          
          @if (loadingData) {
            <div class="flex justify-center align-center p-lg">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          }
          
          @if (dataLoadError && !loadingData) {
            <div class="error-message p-sm text-secondary">
              <mat-icon svgIcon="error" class="error-icon"></mat-icon>
              {{ dataLoadError }}
            </div>
          }
          
          @if (dataRows.length > 0 && !loadingData) {
            <div class="data-table-wrapper">
              <table mat-table [dataSource]="dataRows">
                @for (column of displayedColumns; track column) {
                  <ng-container [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                    <td mat-cell *matCellDef="let row" 
                        class="truncate-cell"
                        [matTooltip]="getCellValue(row[column])"
                        [matTooltipDisabled]="!shouldShowTooltip(row[column])">
                      {{ getCellValue(row[column]) }}
                    </td>
                  </ng-container>
                }
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

@if (!dataSource && !uploadedFile) {
  <div class="empty-state">
    <mat-icon svgIcon="info" class="empty-icon"></mat-icon>
    <p class="text-secondary">No data source selected</p>
  </div>
}
